import styled from 'styled-components';
import { Palette } from 'config';

export const EmptySearchResult = styled.h3`
  width: 100%;
  text-align: center;
  margin-top: 32px;
  font-weight: 400;
  font-size: 0.75em;
  line-height: 1em;
  color: ${Palette.PrimaryGray._700};
`;
